import { Filter } from '@/interfaces/filter.interface'
import { APIBillingCode } from '@/models/api/billing-code.model'
import { BillingCodesServices } from '@/services/modules/billing-codes.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class BillingCodesStore extends VuexModule {
    billingcodes: object[] = []
    billingcodesPaginate: object[] = []
    billingcodeForm: object|null = null

    @Mutation
    updateBillingCodes (newBillingCodes: object[]) {
        this.billingcodes = newBillingCodes
    }

    @Mutation
    updateBillingCodesPaginate (newBillingCodes: object[]) {
        this.billingcodesPaginate = newBillingCodes
    }

    @Mutation
    updateBillingCode (newBillingCode: object) {
        this.billingcodeForm = newBillingCode
    }

    @Action
    getBillingCodes () {
        return new Promise((resolve) => {
            BillingCodesServices.getBillingCodes()
                .then(resp => {
                    store.commit('updateBillingCodes', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getBillingCodesPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = { page: params.page, limit: params.limit, sortBy: params.sortBy, sort: params.sort }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            BillingCodesServices.getBillingCodesPaginate(newParams)
                .then(resp => {
                    store.commit('updateBillingCodesPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getBillingCodesById (id: number) {
        return new Promise((resolve) => {
            BillingCodesServices.getBillingCodesById(id)
                .then(resp => {
                    store.commit('updateBillingCode', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editBillingCodes (params: APIBillingCode) {
        params = new APIBillingCode(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIBillingCode)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            BillingCodesServices.editBillingCodes(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createBillingCodes (params: APIBillingCode) {
        params = new APIBillingCode(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIBillingCode)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            BillingCodesServices.createBillingCodes(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteBillingCodes (id: number) {
        return new Promise((resolve) => {
            BillingCodesServices.deleteBillingCodes(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    restoreBillingCodes (id: number) {
        return new Promise((resolve) => {
            BillingCodesServices.restoreBillingCodes(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
